import React from 'react';
import './Header.css';
import logo from './falometro_logo_preto_arial.svg';

class Header extends React.Component {
    render () {
        const isLoaded = this.props.isLoaded;
        let nomeCidade;
        if (isLoaded) {
            nomeCidade = this.props.selecionada.cidade;
        }

        return (
            <header className="header-home">
                <nav className="navbar navbar-expand-md navbar-dark fixed-top bg-dark">
                    <a className="navbar-brand" href="/"><img alt="Falometro" src={logo} height={40}/></a>
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item active">
                            <a className="nav-link" href="/">{nomeCidade} <span className="sr-only">(current)</span></a>
                        </li>
                    </ul>
                    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"/>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                        <ul className="navbar-nav mr-auto"/>
                        <form className="form-inline mt-2 mt-md-0">
                            <select className="custom-select" onChange={this.props.onChangeCidade} value={nomeCidade}>
                            {
                                this.props.cidades.map(cidade => {
                                    return <option value={cidade}>{cidade}</option>
                                })
                            }
                            </select>
                        </form>
                    </div>
                </nav>
            </header>
        )
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/scenes/Home/components/Header.js